module.exports = __webpack_public_path__ + "assets/img/eworldGame.2bb8da77.png";